const chartTypes = {
  RADAR_CHART_DATA: "RADAR_CHART_DATA",
  RADAR_CHART_DATA_SUCCESS: "RADAR_CHART_DATA_SUCCESS",
  RADAR_CHART_DATA_FAILURE: "RADAR_CHART_DATA_FAILURE",
};

export default chartTypes;
